import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import departmentService from './department.service';

export interface DepartmentState { }

const DepartmentStore: Module<DepartmentState, StoreState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async get({ commit }, { company_id }: { company_id: number }) {
            return await departmentService.get({ company_id }).then((response) => response.data);
        },
    },
};

export default DepartmentStore;
